/**
 * Note Error Code and respective translations are maintained in Google Sheet below:
 * https://docs.google.com/spreadsheets/d/1MIpqqGAFE3aEAfXjAoONybjYhLz4FmEHNdiWcvtJDU0/edit?gid=1363316935#gid=1363316935
 *
 * How to
 * 1. open Google Sheet above
 * 2. Select "error-messages" tab
 * 3. Make desired updates in columns A,B and C.
 *    !! IMPORTANT: DO NOT EDIT OTHER COLUMNS !!
 * 4. copy contents of column S and paste below replacing export enum ErrorCode {
 *
 */
export enum ErrorCode {
  // Permission related errors (1xxx)
  UNAUTHORIZED = 1001,
  INVALID_TOKEN = 1002,
  TOKEN_EXPIRED = 1003,
  INSUFFICIENT_PERMISSIONS = 1004,
  FORBIDDEN = 1005,

  // Form Input | Reuest Payload Validation | Not Found errors (2xxx)
  VALIDATION_FAILED = 2001,
  INVALID_INPUT = 2002,
  MISSING_REQUIRED_FIELD = 2003,
  INVALID_DATE_FORMAT = 2004,
  INVALID_EMAIL_FORMAT = 2005,
  INVALID_PHONE_FORMAT = 2006,
  NOT_FOUND = 2100,
  CONFIG_NOT_FOUND = 2102,
  USER_NOT_FOUND = 2103,
  CUSTOMER_NOT_FOUND = 2104,
  MEMBER_NOT_FOUND = 2105,
  BOOKING_NOT_FOUND = 2106,
  PRODUCT_NOT_FOUND = 2107,
  PRODUCT_SIZE_NOT_FOUND = 2108,
  ORDER_NOT_FOUND = 2109,
  ORDER_ITEM_NOT_FOUND = 2110,
  RESTAURANT_NOT_FOUND = 2111,

  PRE_ORDERING_CLOSED = 2112,

  // Frontend errors (3xxx)

  // Backend | Server | Database errors (4xxx)
  SERVER_ERROR = 4001, // generic backend
  DATABASE_ERROR = 4002, // generic Firestore
  BIGQUETY_ERROR = 4003,
  CACHE_ERROR = 4004,

  // Business logic errors (5xxx)
  PRODUCT_STOCK_HIDDEN = 5001,
  PRODUCT_STOCK_SOLD_OUT = 5002,
  PRODUCT_STOCK_NOT_AVAILABLE = 5003,
  PRODUCT_NOT_AVAILABLE = 5004,
  PRODUCT_NOT_IN_MENU = 5005,
  PRODUCT_NOT_IN_BASKET = 5006,
  PRODUCT_DISABLED = 5007,
  PRODUCT_FROM_DISABLED_SERVICE = 5008,

  CANNOT_SEND_ORDER = 5100,
  SERVICE_NOT_AVAILABLE = 5101,
  SERVICE_HAS_ENDED = 5102,
  MENU_HEADING_DISABLED = 5200,
  MENU_HEADING_NOT_AVAILABLE = 5201,
  MENU_OPTION_ERROR = 5202,
  MENU_INCLUSION_ERROR = 5203,
  MENU_INCLUSION_LIMIT_REACHED = 5204,
  MENU_INCLUSION_ITEM_NOT_INCLUDED = 5205,

  NO_MEAL_ID = 5206,

  MENU_QR_CONFLICT = 5207,
  // Third-party service errors (6xxx)
  // GC 60x
  GCS_API_ERROR = 6001,

  // stripe 61x
  STRIPE_API_ERROR = 6100,

  // sendgrid 62x
  SENDGRID_API_ERROR = 6200,
  EMAIL_DELIVERY_FAILED = 6201,

  // sendgrid 62x
  SMSGLOBAL_API_ERROR = 6300,
  TRANSACTIONAL_SMS_DELIVERY_FAILED = 6301,
  TRANSACTIONAL_MMS_DELIVERY_FAILED = 6302,
  MARKETING_SMS_DELIVERY_FAILED = 6303,
  MARKETING_MMS_DELIVERY_FAILED = 6304,

  // Unknown error (9xxx)
  UNKNOWN_ERROR = 9001,
}

export interface ErrorItems {
  [id: string]: ErrorItem;
}

export interface ErrorItem {
  code: ErrorCode;
  message?: string;
  timeStamp?: string;
  context?: ErrorContext;
}

export interface ErrorContext {
  [key: string]: any;
}

export interface ClientErrorResponse {
  message: string;
  info: unknown;
}
